import {store} from '../app/store';

export const checkIfAllSectionsAreValid = () => {
  const sections: any = store.getState().changeData.sectionStatus;
  let status = true;
  let invalidSection = '';
  sections.forEach((element: any) => {
    if (!element.valid) {
      status = false;
      invalidSection = element.section;
      return;
    }
  });
  return {status, invalidSection};
};

export const checkIfAllSectionsAreSaved = () => {
  const sections: any = store.getState().changeData.sectionStatus;
  let status = true;
  let unsavedSection = '';
  sections.forEach((element: any) => {
    if (!element.saveStatus) {
      status = false;
      unsavedSection = element.section;
      return;
    }
  });
  return {status, unsavedSection};
};
